$(document).ready(function() {
    $('body').on('click', '.cart-btn,.cart-all-btn', function() {
        if ($(".cart-count-bubble").length) {} else {
            $(".header__icon--cart").append('<div class="cart-count-bubble"><span aria-hidden="true">0</span></div>');
        }
    });
$('body').on('click', '.iWishAdd,.product-recommendations__grid-wrapper .grid .grid__item .card-product .iWishAddColl', function() {
    setTimeout(function() {
        document.querySelector('.iwish-float-icon,.iWishView').click()
    }, 500);
});
jQuery(document).ready(function() {
    setTimeout(function() {
        var iwC1 = $('.iw-link__count').text();
        console.log("iwC1: ", iwC1);
        if (iwC1 > 0) {
            $('.iw-link__count').show();
        } else {
            $('.iw-link__count').hide();
        }
    }, 2000);
    jQuery("body").on("click", ".iWishAdd, .iwish-backdrop,.iwish_drawer_close", function() {
        setTimeout(function() {
            var iwC1 = jQuery('.iw-link__count').text();
            console.log("iwC1click: " + iwC1);
            if (iwC1 > 0) {
                jQuery('.iw-link__count').show();
            } else {
                jQuery('.iw-link__count').hide();
            }
        }, 500);
    });
});

});
 $('body').on('click','.cart-btn,.cart-all-btn',function(){
    setTimeout(()=>{
     window.location.href ="https://orthoshop-america.myshopify.com/cart";
    },1000)
})